import { createRouter, createWebHistory } from "vue-router";
import ErrorComponent from "@/components/ErrorComponent.vue";
import PolitiqueCookies from "../views/PolitiqueCookies.vue";
import ConversationInternet from "../views/ConversationInternet.vue";
import PolitiqueConfidentialite from "../views/PolitiqueConfidentialite.vue";
import MentionsLegales from "@/views/MentionsLegales.vue";
import ConditionsGenerales from "@/views/ConditionsGenerales.vue";
import NonAutorise from "@/views/NonAutorise.vue";
// import axios from "axios";
const router = createRouter({
  history: createWebHistory(), //
  routes: [
    {
      path: "/:catchAll(.*)",
      name: "404",
      meta: {
        title: "404",
      },
      component: ErrorComponent,
    },
    {
      path: "/nonautorise",
      name: "nonautorise",
      meta: {
        title: "non autorisé",
        requiresAuth: true,
      },
      component: NonAutorise,
    },

    {
      path: "/",
      name: "internet",
      meta: {
        title: "Bot-Internet",
        requiresAuth: false,
      },
      component: ConversationInternet,
      props: (route) => ({
        flag: route.params.flag,
      }),
    },

    {
      path: "/:flag",
      name: "internetWithFlag",
      meta: {
        title: "Bot-Internet",
        requiresAuth: false,
      },
      component: ConversationInternet,
      props: (route) => ({
        flag: route.params.flag,
      }),
    },

    {
      path: "/politiqueConfidentialite",
      name: "politiqueConfidentialite",
      meta: {
        title: "politique-confidentialité",
        requiresAuth: false,
      },
      component: PolitiqueConfidentialite,
    },
    {
      path: "/politiquegestioncookies",
      name: "politiquegestioncookies",
      meta: {
        title: "politique-gestion-cookies",
        requiresAuth: false,
      },
      component: PolitiqueCookies,
    },

    {
      path: "/mentionslegales",
      name: "mentionslegales",
      meta: {
        title: "Mentions légales",
      },
      component: MentionsLegales,
      props: true,
    },
    {
      path: "/conditionsgenerales",
      name: "conditionsgenerales",
      meta: {
        title: "Conditions Générales d'utilisations",
      },
      component: ConditionsGenerales,
      props: true,
    },
  ],
  transition: {
    name: "fade",
    mode: "out-in",
  },
  strict: true,
});

window.addEventListener("beforeunload", function () {
  localStorage.removeItem("provenance");
});

router.beforeEach(async (to, from, next) => {
  if (to.params.flag) {
    localStorage.setItem("provenance", to.params.flag);
    next({ name: "internet" });
  } else {
    next();
  }
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
